<template>
  <div class="page page-documents">
    <div class="page-documents__content">
      <img
        alt="delimobil cars"
        class="page-documents__image"
        src="/img/06@2x.jpg"
        v-if="!isMobile"
      />
      <ul class="page-documents__articles">
        <li class="page-documents__articles-item ">
          <a class="page-documents__articles-link" href="/documents/2021_sout_result_and_recommendations.pdf">
            СОУТ
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { isMobile } from '@/mixins/isMobile';

export default {
  name: 'Documents',
  mixins: [isMobile]
};
</script>
